import {SideBar} from 'components/src/sidebar/SideBar'
import {Home as HomeIcon, PrivacyPolicy as PdfIcon} from "iconoir-react";
import {useTranslation} from "react-i18next";

/**
 * AppSidebar component provides the main navigation sidebar of the application.
 */
export const PortalSidebar = () =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation();

    return (
        <SideBar>
            <SideBar.Item title={t('portal.sidebar.home-title')} link="/" icon={<HomeIcon/>}/>
            <SideBar.Item title={t('portal.sidebar.pdf-password-title')} link="/pdf/otp" icon={<PdfIcon/>}/>
        </SideBar>
    )
}
